export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FormRegister.vue?vue&type=style&index=0&id=4873afb6&prod&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/components/login/FormRegister.vue?vue&type=style&index=0&id=4873afb6&prod&lang=css&
// module id = 937
// module chunks = 0